<taku-form-header
  displayMode="full"
  (backClicked)="goBack()"
  toolbarTitle="Payment Settings"
  [showActionBtns]="false"
  [showBackBtn]="true"
></taku-form-header>

<taku-form-list
  *ngIf="active"
  [_hideAddLineHeaderBtn]="true"
  [_deleteRowEvent]="checkIfCanDeleteDialog"
  [ngClass]="{ pullDown: true }"
  _model="takuPaymentGateway"
  _detailMode="w"
  [_title]="_formlistTitle"
  [_filter]="_formListFilter"
  [_defaultRowValues]="_defaultRowValues"
  [_bulkEditorEnabled]="false"
  (onRowsFetched)="registerRowFormsChanges()"
  (_onRowsDiscarded)="registerRowFormsChanges()"
  (_allRowsSaved)="onPaymentGatewaysSaved($event)"
  _hideSavingCtrls="true"
></taku-form-list>

<p-confirmDialog
  [key]="confirmDialogKey"
  header="Confirmation"
  icon="ui-icon-help"
  [style]="{ width: '300pt', maxWidth: 'calc(100vw - 18pt)' }"
></p-confirmDialog>
